import { useTranslation } from "react-i18next";
import type { DealerDeviceTransferNotification } from "@/gql/graphql";
import DataListItemText from "./DataListItemText";

type DeviceTransferRequestDeclinedNotificationProps = {
  data: Pick<DealerDeviceTransferNotification, "model" | "serialNumber">;
};

const DeviceTransferRequestDeclinedNotification = (
  props: DeviceTransferRequestDeclinedNotificationProps
) => {
  const { data } = props;
  const { model, serialNumber } = data;
  const { t } = useTranslation();

  return (
    <DataListItemText
      primary={t("notifications.device_transfer_request_declined.title")}
      secondary={t(
        "notifications.device_transfer_request_declined.description",
        { model: model ?? "", serialNumber }
      )}
    />
  );
};

export default DeviceTransferRequestDeclinedNotification;
